import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  data: [],
  dataTemp: [],
  reminders: []
};

const Authentication = createSlice({
  name: "Authlogin",
  initialState,
  reducers: {
    authlogin: (state, action) => {
      state.data = action.payload;
    },
    authtemplogin: (state, action) => {
      state.dataTemp = action.payload;
    },
    reminerData: (state, action) => {
      state.reminders = action.payload;
    },
    authlogout: (state, action) => {
      state.data = [];
      state.dataTemp = []
      state.reminders = []
    },
    clearAuthTempLogin: (state) => {
      state.dataTemp = [];
    }
  },
});
export const { authlogin, authlogout, reminerData, authtemplogin, clearAuthTempLogin } = Authentication.actions;
export default Authentication.reducer;
